import React from 'react';
import type { DeletedDomainItem } from '@/types';

export function useDeletedDomainsSorting(domains: DeletedDomainItem[]) {
  const [sortDescriptor, setSortDescriptor] = React.useState<{
    column: keyof DeletedDomainItem | undefined;
    direction: 'ascending' | 'descending';
  }>({
    column: undefined,
    direction: 'ascending'
  });

  const sortedDomains = React.useMemo(() => {
    if (!sortDescriptor.column) return domains;

    return [...domains].sort((a, b) => {
      const first = a[sortDescriptor.column!];
      const second = b[sortDescriptor.column!];

      // Handle null/undefined values
      if (first == null && second == null) return 0;
      if (first == null) return 1;
      if (second == null) return -1;

      const cmp = first < second ? -1 : first > second ? 1 : 0;
      return sortDescriptor.direction === 'descending' ? -cmp : cmp;
    });
  }, [domains, sortDescriptor]);

  return {
    sortDescriptor,
    setSortDescriptor,
    sortedDomains
  };
}
